module.exports = __webpack_public_path__ + "img/img-card-2.2eb15e02.png";